import * as React from "react";

import { cn } from "@/lib/utils";

// Form Field with a native select, styled like NvFormField (48px, "▾" on the right — Figma 기업 소재국).
export interface NvSelectFieldProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label: React.ReactNode;
  required?: boolean;
  error?: string;
  placeholder?: string;
  options: { value: string; label: string }[];
}

const NvSelectField = React.forwardRef<HTMLSelectElement, NvSelectFieldProps>(
  ({ label, required, error, placeholder, options, id, className, value, ...props }, ref) => {
    const autoId = React.useId();
    const selectId = id ?? autoId;
    return (
      <div className={cn("flex flex-col gap-[6px]", className)}>
        <label htmlFor={selectId} className="text-nv-label-md text-nv-text-strong">
          {label}
          {required && " *"}
        </label>
        <div className="relative">
          <select
            ref={ref}
            id={selectId}
            required={required}
            value={value}
            aria-invalid={error ? true : undefined}
            className={cn(
              "w-full appearance-none rounded-nv-control border bg-nv-surface py-3 pl-[14px] pr-10 text-nv-body-md focus-visible:border-nv-brand focus-visible:outline-none",
              value ? "text-nv-text-strong" : "text-nv-text-placeholder",
              error ? "border-nv-danger" : "border-nv-border-strong",
            )}
            {...props}
          >
            {placeholder && (
              <option value="" disabled>
                {placeholder}
              </option>
            )}
            {options.map((option) => (
              <option key={option.value} value={option.value} className="text-nv-text-strong">
                {option.label}
              </option>
            ))}
          </select>
          <span aria-hidden className="pointer-events-none absolute right-[14px] top-1/2 -translate-y-1/2 text-[11px] text-nv-text-placeholder">
            ▾
          </span>
        </div>
        {error && <p className="text-nv-caption text-nv-danger">{error}</p>}
      </div>
    );
  },
);
NvSelectField.displayName = "NvSelectField";

export { NvSelectField };
